<template>
  <v-card flat rounded="lg">
    <v-card-text class="text-center">
      <v-icon size="75" color="success">mdi-text-box-check-outline</v-icon>
      <template v-if="isOnline()">
        <h2 class="mt-4 success--text">
          Pedido nº {{ id > 0 ? id : this.$route.params.id }} emitido com
          sucesso
        </h2>
        <v-btn
          rounded
          class="mt-7"
          color="success"
          :outlined="!isMobile()"
          block
          @click="visualizarPedido()"
          >Visualizar</v-btn
        >
        <v-btn
          @click="$router.replace({path: '/'})"
          class="mt-3"
          rounded
          text          
          >Fechar</v-btn
        >
      </template>
      <template v-else>
        <h2 class="mt-4 success--text">Pedido Emitido Offline</h2>
        <p>
          Ele será enviado para o sistema assim que você estiver conectado à
          rede
        </p>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    id: { type: Number, default: 0 },
  },
  computed: mapState("usuario", ["usuarioLogado"]),
  methods: {
    visualizarPedido() {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/detec/extrato-pedido?token=${
          this.usuarioLogado.token_detec
        }&pedido=${this.id > 0 ? this.id : this.$route.params.id}`,
        "_blank"
      );
    },
    isMobile() {
      return this.$mq == "sm";
    },
    isOnline() {
      return navigator.onLine;
    },
  },
};
</script>

<style>
</style>